<template>
  <div>
  <div v-bind:class="{ sidebar: isSidebarShow, NonSidebar: !isSidebarShow }">
    <div class="title">
      ep-Manager
    </div>
    <div class="company">
      {{name}}
    </div>
    <div v-if="role === 'worker' && !supervisor">
      <div class="subItem">メニュー
      </div>
      <div v-bind:class="{ active: nombreRuta.indexOf('/notifications') === 0 }" class="item" @click="notification">
        お知らせ
      </div>
      <div v-bind:class="{ active: nombreRuta.indexOf('/entrances') === 0 }" class="item" @click="entrance">
        入退場履歴
      </div>
      <div class="subItem">マイアカウント
      </div>
      <div v-bind:class="{ active: nombreRuta.indexOf('/companies/me') === 0 }" class="item" @click="account">
        登録情報
      </div>
      <div class="subItem">会員
      </div>
      <div v-bind:class="{ active: nombreRuta.indexOf('/users/change-password') === 0 }" class="item" @click="passwordChange">
        パスワード変更
      </div>
      <div class="item" @click="openModal">
        ログアウト
      </div>
    </div>
    <div v-if="role === 'worker' && supervisor">
      <div class="subItem">メニュー
      </div>
      <div v-bind:class="{ active: nombreRuta.indexOf('/notifications') === 0 }" class="item" @click="notification">
        お知らせ
      </div>
      <div v-bind:class="{ active: nombreRuta.indexOf('/entrances') === 0 }" class="item" @click="entrance">
        入退場履歴
      </div>
      <div v-bind:class="{ active: nombreRuta.indexOf('/sites') === 0 }" class="item" @click="site">
        現場一覧
      </div>
      <div class="subItem">マイアカウント
      </div>
      <div v-bind:class="{ active: nombreRuta.indexOf('/companies/me') === 0 }" class="item" @click="account">
        登録情報
      </div>
      <div class="subItem">会員
      </div>
      <div v-bind:class="{ active: nombreRuta.indexOf('/users/change-password') === 0 }" class="item" @click="passwordChange">
        パスワード変更
      </div>
      <div class="item" @click="openModal">
        ログアウト
      </div>
    </div>
    <div v-else-if="role === 'business'">
      <div class="subItem">メニュー
      </div>
      <div v-bind:class="{ active: nombreRuta.indexOf('/notifications') === 0 }" class="item" @click="notification">
        お知らせ
      </div>
      <div v-bind:class="{ active: nombreRuta.indexOf('/companies-groups') === 0 }"  class="item" @click="branch">
        支店管理
      </div>
      <div v-bind:class="{ active: nombreRuta.indexOf('/workers') === 0 }" class="item" @click="worker">
        技能者管理
      </div>
      <div v-bind:class="{ active: nombreRuta.indexOf('/sites') === 0 }" class="item" @click="site">
        現場管理
      </div>
      <div v-bind:class="{ active: nombreRuta.indexOf('/entrances') === 0 }" class="item" @click="entrance">
        入退場履歴
      </div>
      <div class="subItem">マイアカウント
      </div>
      <div v-bind:class="{ active: nombreRuta.indexOf('/companies/me') === 0 }" class="item" @click="account">
        登録情報
      </div>
      <div class="subItem">会員
      </div>
      <div v-bind:class="{ active: nombreRuta.indexOf('/users/change-password') === 0 }" class="item" @click="passwordChange">
        パスワード変更
      </div>
      <div class="item" @click="openModal">
        ログアウト
      </div>
    </div>
    <div v-else-if="role === 'branch'">
      <div class="subItem">メニュー
      </div>
      <div v-bind:class="{ active: nombreRuta.indexOf('/notifications') === 0 }" class="item" @click="notification">
        お知らせ
      </div>
      <div v-bind:class="{ active: nombreRuta.indexOf('/workers') === 0 }" class="item" @click="worker">
        技能者管理
      </div>
      <div v-bind:class="{ active: nombreRuta.indexOf('/sites') === 0 }" class="item" @click="site">
        現場管理
      </div>
      <div v-bind:class="{ active: nombreRuta.indexOf('/entrances') === 0 }" class="item" @click="entrance">
        入退場履歴
      </div>
      <div class="subItem">会員
      </div>
      <div v-bind:class="{ active: nombreRuta.indexOf('/users/change-password') === 0 }" class="item" @click="passwordChange">
        パスワード変更
      </div>
      <div class="item" @click="openModal">
        ログアウト
      </div>
    </div>
    <div v-else-if="role == 'admin'">
      <div class="subItem">メニュー
      </div>
      <div v-bind:class="{ active: nombreRuta.indexOf('/notifications') === 0 }" class="item" @click="notification">
        お知らせ
      </div>
      <!-- <div v-bind:class="{ active: nombreRuta.indexOf('/cardReader') === 0 }" class="item" @click="cardReader">
        カードリーダー管理
      </div> -->
      <!-- <div v-bind:class="{ active: nombreRuta.indexOf('/companies-groups') === 0 }"  class="item" @click="branch">
        支店管理
      </div> -->
      <div v-bind:class="{ active: nombreRuta.indexOf('/sites') === 0 }" class="item" @click="site">
        現場管理
      </div>
      <div v-bind:class="{ active: nombreRuta.indexOf('/entrances') === 0 }" class="item" @click="entrance">
        入退場履歴
      </div>
      <div v-bind:class="{ active: nombreRuta.indexOf('/loginLog/-') === 0 }" class="item" @click="loginLog">
        ログイン履歴
      </div>
      <div class="subItem">利用者管理
      </div>
      <div v-bind:class="{ active: nombreRuta.indexOf('/business') === 0 }" class="item" @click="business">
        事業者管理
      </div>
      <div v-bind:class="{ active: nombreRuta.indexOf('/workers') === 0 }" class="item" @click="worker">
        技能者管理
      </div>
      <div class="subItem">会員
      </div>
      <div v-bind:class="{ active: nombreRuta.indexOf('/users/change-password') === 0 }" class="item" @click="passwordChange">
        パスワード変更
      </div>
      <div class="item" @click="openModal">
        ログアウト
      </div>
    </div>
    <!-- <div class="subItem" style="margin-top: 200px; font-size: 1rem;">
      {{ $store.getters.role }}
    </div> -->
  </div>

  <div v-bind:class="{ ear: isSidebarShow, NonEar: !isSidebarShow }" @click="operateSidebar()">＞</div>

  <Modal size="logout" @close="closeModal" v-if="modal">
    <p class="modalTitle">ログアウトしますか？</p>
    <!-- ローディング -->
    <div v-if="postLodingFlg">
      <vue-loading
        type="cylon"
        color="#1b7e47"
        :size="{ width: '150px', height: '150px' }"
      >
      </vue-loading>
      <div v-if="postLodingFlg" style="padding: 0px 0px 30px 0px;">Now registering...</div>
    </div>
    <!-- 更新エラー表示 -->
    <div v-if="postErrorFlg" style="padding: 0px 0px 30px 0px; margin: auto;">
      <div　class="errMsg">
        <div class="errDiv">
          ログアウト処理中に問題が発生しました。
        </div>
      </div>
    </div>
      <button @click="logout" class="logoutYes" v-if="!postLodingFlg">はい</button>
      <button @click="closeModal" class="logoutNo" v-if="!postLodingFlg">キャンセル</button>
  </Modal>
</div>
</template>

<script lang='ts'>
import { Component, Vue } from 'vue-property-decorator';
import Modal from './BaseModal.vue';
import ApiClient from '../services/ApiClient';
import { VueLoading } from 'vue-loading-template';

export default {
  name: 'Sidebar',
  components: {
    Modal,
  },
  created() {
    this.nombreRuta = this.$route.fullPath;
    this.setName();
  },
  data() {
    return {
      name: '',
      modal: false,
      // role: this.$store.getters.role,
      // isSidebarShow: this.$store.getters.isSidebarShow,
      // ローディング
      postLodingFlg: false, // データ更新時ローディングフラグ
      postErrorFlg: false,  // データ更新時エラーフラグ
    };
  },
  mounted() {
  },
  computed: {
    role() {
      return this.$store.getters.session.role;
    },
    isSidebarShow() {
      return this.$store.getters.session.isSidebarShow;
    },
    supervisor() {
      if(this.$store.getters.session.supervisor) {
        return true;
      } else {
        return false;
      }
    },
  },
  watch: {
    role() {
      this.$nextTick(() => {
        // 必要であれば処理を書く 現状必要なロジックはない
      });
    },
    isSidebarShow() {
      this.$nextTick(() => {
        // 必要であれば処理を書く 現状必要なロジックはない
      });
    },
  },
  methods: {
    async setName() {
      // 10文字以上は省力する
      const session = this.$store.getters.session;
      if (!session.name) {
        this.name = '';
      } else {
        const name = session.name;
        const maxLength = 10;
        if (name.length > maxLength) {
          this.name = name.substring(0, maxLength) + '...';
        } else {
          this.name = name;
        }
      }

    },
    operateSidebar() {
      const session = this.$store.getters.session;
      session.isSidebarShow = !this.isSidebarShow;
      this.$store.commit('setSession', session);
      // this.$store.commit('setIsSidebarShow', {
      //   isShow: !this.isSidebarShow,
      // });
    },
    isCurrent(next) {
      return this.nombreRuta === next;
    },
    openModal() {
      this.modal = true;
    },
    closeModal() {
      this.modal = false;
    },
    async logout() {
      try {
        // ローディング表示
        // this.postLodingFlg = true;
        // ログアウト前に再度認証取得(有効期限切れでログアウトAPIが呼び出せないことがあるため)
        await this.$cognito.isAuthenticated();
        // ログアウト履歴登録
        this.postLoginLog();

        // Cognito サインアウト
        await this.$cognito.signout();
        this.$store.commit('reset');
        this.$router.push('/');
      } catch (error) {
        this.postErrorFlg = true;
      } finally {
        // ローディング非表示
        this.postLodingFlg = false;
      }
    },

    // ログアウト履歴登録
    async postLoginLog() {
      try {
        const restResourceService = new ApiClient();
        // クライアントのユーザーエージェント取得
        const ua = navigator.userAgent;
        // Body用意
        const body = {
          ua,
          type: 0,
        };
        // ログイン情報を登録
        await restResourceService.postLoginLogs(body);
      } catch (error) {
      }
    },

    notification() {
      const next = '/notifications';
      if (this.isCurrent(next)) {
        return;
      }
      this.$router.push(next);
    },
    cardReader() {
      const next = '/cardReader';
      if (this.isCurrent(next)) {
        return;
      }
      this.$router.push(next);
    },
    entrance() {
      const next = '/entrances';
      if (this.isCurrent(next)) {
        return;
      }
      this.$router.push(next);
    },
    loginLog() {
      const next = '/loginLog/-';
      if (this.isCurrent(next)) {
        return;
      }
      this.$router.push(next);
    },
    branch() {
      const next = '/companies-groups';
      if (this.isCurrent(next)) {
        return;
      }
      this.$router.push(next);
    },
    business() {
      const next = '/business';
      if (this.isCurrent(next)) {
        return;
      }
      this.$router.push(next);
    },
    worker() {
      const next = '/workers';
      if (this.isCurrent(next)) {
        return;
      }
      this.$router.push(next);
    },
    site() {
      const next = '/sites';
      if (this.isCurrent(next)) {
        return;
      }
      this.$router.push(next);
    },
    account() {
      const next = '/companies/me';
      if (this.isCurrent(next)) {
        return;
      }
      this.$router.push(next);
    },
    passwordChange() {
      const next = '/users/change-password';
      if (this.isCurrent(next)) {
        return;
      }
      this.$router.push(next);
    },
  },
};
</script>

<!-- Add 'scoped' attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../style/variables.scss";

.title {
  margin: 30px auto;
  font-weight: bold;
  font-size: $font-large;
  color: $font_color;
}
.company {
  text-align: left;
  color: $font_color;
  margin-right: 10px;
  font-size: $font-medium;
  border-bottom: 1px solid $theme_color;
  padding: 0 1rem 0.5rem 1rem;
}

.modalTitle {
  margin: 30px auto;
  font-weight: bold;
  font-size: $font-medium;
  color: $font_color;
}
.logoutYes {
  background-color: $button-primary;
  color: $active_font_color;
  font-size: $font-medium;
  width: 200px;
  height: 50px;
  padding: 10px, 10px;
  margin-bottom: 20px;
  border-radius: 10px;
  border: none;
  cursor: pointer;
  outline: none;
  appearance: none;
  font-weight: bold;
}
.logoutNo {
  background-color: $button-danger;
  color: $active_font_color;
  font-size: $font-medium;
  width: 200px;
  height: 50px;
  padding: 10px, 10px;
  border-radius: 10px;
  border: none;
  cursor: pointer;
  outline: none;
  appearance: none;
  font-weight: bold;
}
.sidebar {
  position: fixed;
  // top: 56px;
  top: 0px;
  bottom: 0;
  width: $sidebar-width;
  z-index: 1000;
  background-color: $main_color;
  border-right: 1px solid #dee2e6;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  padding: 0.5rem 0;
}
.NonSidebar {
  position: fixed;
  // top: 56px;
  top: 0px;
  bottom: 0;
  width: $sidebar-width;
  z-index: 1000;
  background-color: $main_color;
  border-right: 1px solid #dee2e6;
  box-sizing: border-box;
  display: none;
  flex-direction: column;
  padding: 0.5rem 0;
}
.ear {
  position: absolute;        /* 要素の配置方法を指定 */
  left: 2px;                /* 左からの位置指定 */
  top: 2px;                 /* 上からの位置指定 */
  transform: rotate( 180deg );
  width: 25px;
  height: 25px;
  line-height: 25px;
  border-radius: 50%;
  background: #dcdcdc;
  display: flex;
  flex-direction: column;
  margin-left: $sidebar-width+5;
  box-sizing: border-box;
}
.NonEar {
  position: absolute;        /* 要素の配置方法を指定 */
  left: 2px;                /* 左からの位置指定 */
  top: 2px;                 /* 上からの位置指定 */
  width: 25px;
  height: 25px;
  line-height: 25px;
  border-radius: 50%;
  background: #dcdcdc;
  display: flex;
  flex-direction: column;
  margin-left: 5px;
  box-sizing: border-box;
}
.item {
  color: $font_color;
  font-size: $font-small;
  height: 48px;
  display: flex;
  align-items: center;
  padding: 0 2rem;
  cursor: pointer;
  &.active {
    color: $active_font_color;
    background-color: $theme_color;
    font-weight: bold;
  }
  &.settings {
    margin-top: auto;
  }
}
.subItem {
  color: $font_color;
  font-size: $font-small;
  height: 24px;
  display: flex;
  align-items: center;
  padding: 1rem 1rem 0 1rem;
}
.icon {
  margin-right: 1rem;
}
</style>
